import { render, staticRenderFns } from "./RefereeCenter.vue?vue&type=template&id=95b5ed46&scoped=true&"
import script from "./RefereeCenter.vue?vue&type=script&lang=js&"
export * from "./RefereeCenter.vue?vue&type=script&lang=js&"
import style0 from "./RefereeCenter.vue?vue&type=style&index=0&id=95b5ed46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95b5ed46",
  null
  
)

export default component.exports